import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getSearchAttSubs, getPageCount, getLoggedInUser } from 'reducers';
import { searchSubs } from 'actions/attSubs';
import SearchSubsComponent from './SearchSubs';
import { can, permActions } from '../../permissions';

const mapStateToProps = (
  state,
  {
    match: {
      params: { page = 1 },
    },
  },
) => {
  let fields = [
    'first_name',
    'last_name',
    'mdn',
    'user_profile',
    'device_id',
    'icc_id',
  ];
  const loggedInUser = getLoggedInUser(state);
  const showImsiSearchField = can(
    loggedInUser,
    permActions.SEARCH_ATT_SUB_BY_IMSI,
  );
  if (showImsiSearchField) {
    fields.push('imsi');
  }
  return {
    subs: getSearchAttSubs(state, page),
    pageCount: getPageCount(state, 'attSubs', `search`, page),
    fields: fields,
    page,
    subscriptionRoute: (subId) => `/att/subscriptions/${subId}/view`,
    pageRoute: (pageNum) => `/att/subsriptions/search/page/${pageNum}`,
    carrierTitle: 'AT&T',
  };
};

const mapDispatchToProps = {
  searchSubs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchSubsComponent),
);
